// extracted by mini-css-extract-plugin
export default {"menuContainer":"menuslider-module--menuContainer--TSH-Z","link":"menuslider-module--link--IGwGT","hidden":"menuslider-module--hidden--7q4K1"};